import React, { ReactElement } from "react";
import styled from "styled-components";
import { FieldProps } from "formik";

interface TextareaBaseProps extends FieldProps {
  placeholder?: string;
  rows?: number;
}

export const BaseTextarea: React.FC<TextareaBaseProps> = ({
  field,
  form,
  placeholder,
  rows = 4,
  ...rest
}): ReactElement => {
  const error = (form.errors as any)?.[field.name];
  const touched = (form.touched as any)?.[field.name];
  const hasError = Boolean(error && touched);

  return (
    <Wrapper>
      <StyledTextarea
        {...field}
        {...rest}
        placeholder={placeholder}
        rows={rows}
        $hasError={hasError}
      />
      {hasError && <ErrorText>{error}</ErrorText>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-bottom: 12px;
`;

const StyledTextarea = styled.textarea<{ $hasError?: boolean }>`
  opacity: 0.5;
  width: 100%;
  min-height: 90px;
  padding: 16px 25px;
  border-radius: 16px;
  background: none;
  resize: none;
  border: 1px solid ${({ $hasError }) => ($hasError ? "#ff4b4b" : "#E46DD6")};

  font-family: "Manrope";
  font-size: 16px;
  color: rgba(254, 255, 255, 0.7);

  &:focus {
    outline: none;
    border-color: ${({ $hasError }) =>
      $hasError ? "#ff4b4b" : "#ff8be4"};
  }

  @media (min-width: 768px) {
    height: 64px;
    font-size: 22px;
  }
`;

const ErrorText = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: #ff4b4b;
`;
